export default function watermark({ contentEl, text }) {
  const canvas = document.createElement("canvas");
  const width = 200;
  const height = 150;
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext("2d");
  ctx.font = "12px Arial";
  ctx.fillStyle = "rgba(200, 200, 200, 0.5)";
  ctx.rotate((-20 * Math.PI) / 180);
  ctx.fillText(text, 20, 100);
  const base64Url = canvas.toDataURL();
  const watermarkDiv = document.createElement("div");
  watermarkDiv.style.top = "0";
  watermarkDiv.style.left = "0";
  watermarkDiv.style.position = "absolute";
  watermarkDiv.style.zIndex = "9999";
  watermarkDiv.style.pointerEvents = "none";
  watermarkDiv.style.width = "100%";
  watermarkDiv.style.height = "100%";
  watermarkDiv.style.background = `url(${base64Url}) left top repeat`;
  contentEl.appendChild(watermarkDiv);
}
